var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  Dende: () => Dende
});
var import_invalidSubquestion = __toModule(require("../error/invalidSubquestion"));
var import_questionHasNoSubquestions = __toModule(require("../error/questionHasNoSubquestions"));
var import_utils = __toModule(require("../utils"));
var import_question = __toModule(require("./question"));
var import_subquestion = __toModule(require("./subquestion"));
class Dende {
  constructor(form) {
    this.form = (0, import_utils.cloneDeep)(form);
    this.question = import_question.Question.create(this, this.form);
    this.subquestions = form.subquestions ? form.subquestions.map((subquestionForm) => import_subquestion.Subquestion.create(this, subquestionForm)) : void 0;
  }
  isMultioption() {
    return this.getQuestion().getType() === "Multioption";
  }
  isSingleoption() {
    return this.getQuestion().getType() === "Singleoption";
  }
  isCollection() {
    return this.isMultioption() || this.isSingleoption();
  }
  getSubquestionsAsOptions() {
    if (!this.subquestions) {
      throw new import_questionHasNoSubquestions.QuestionHasNoSubquestions(this.getQuestion().getType());
    }
    return this.subquestions.map((subquestion) => {
      return {
        label: subquestion.getLabel(),
        value: subquestion.getValue()
      };
    });
  }
  getQuestion() {
    return this.question;
  }
  getRenderForm() {
    var _a;
    const questionRenderForm = this.question.getRenderForm();
    const renderForm = __spreadProps(__spreadValues({}, questionRenderForm), {
      hasError: this.isMultioption() ? void 0 : !this.getQuestion().isValid(),
      errorMsg: this.isMultioption() ? void 0 : this.getQuestion().getValidationError()
    });
    if (this.isSingleoption()) {
      return (0, import_utils.cloneDeep)(__spreadProps(__spreadValues({}, renderForm), { options: this.getSubquestionsAsOptions() }));
    }
    const subquestions = (_a = this.subquestions) == null ? void 0 : _a.map((subquestion) => {
      const subquestionRenderForm = subquestion.getRenderForm();
      return __spreadProps(__spreadValues({}, subquestionRenderForm), {
        hasError: !subquestion.isValid(),
        errorMsg: subquestion.getValidationError()
      });
    });
    return (0, import_utils.cloneDeep)(__spreadProps(__spreadValues({}, renderForm), { subquestions }));
  }
  getSubquestions() {
    return this.subquestions;
  }
  getSubquestionValidation(subquestion) {
    if (!subquestion || !(subquestion instanceof import_subquestion.Subquestion)) {
      throw new import_invalidSubquestion.InvalidSubquestion();
    }
    return {
      hasError: !subquestion.isValid(),
      errorMsg: subquestion.getValidationError()
    };
  }
  getValueForm() {
    if (this.isMultioption()) {
      const subquestions = this.subquestions.reduce((acc, next) => {
        const value = next.getValue();
        return __spreadProps(__spreadValues({}, acc), { [next.getId()]: value === void 0 ? next.getValueDefault() : value });
      }, {});
      return {
        id: this.question.getId(),
        subquestions
      };
    }
    return {
      id: this.question.getId(),
      value: this.question.getValue() === void 0 ? this.question.getValueDefault() : this.question.getValue()
    };
  }
  isValid() {
    if (this.isMultioption()) {
      return this.subquestions.every((subquestion) => subquestion.isValueValid(subquestion.getValue()));
    }
    return this.question.isValueValid(this.question.getValue());
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Dende
});
